const attempt = (fn) => {
    try {
        return fn();
    } catch (e) {
        return null;
    }
};

const meta = document.querySelector('meta[name="v1-gate"]');
const fromMeta = meta ? meta.content : null;

if (fromMeta) {
    // Plaid OAuth returns top-level to /oauth, which has no meta: hand the token over via localStorage.
    attempt(() => window.localStorage.setItem('v1-gate', fromMeta));
}

const stored = !fromMeta && window.location.pathname === '/oauth'
    ? attempt(() => window.localStorage.getItem('v1-gate'))
    : null;

// Token format 1.<exp>.<guid>.<sig>; exp is unix seconds.
const isFresh = (token) => !!token && Number(token.split('.')[1]) > Date.now() / 1000;

export const v1Gate = fromMeta || (isFresh(stored) ? stored : null);

const isSameOrigin = (url) => {
    const target = attempt(() => new URL(url, document.baseURI));

    return !!target && target.origin === window.location.origin;
};

export const withV1Gate = (url) => {
    if (!v1Gate || !url) {
        return url;
    }

    const target = new URL(url, window.location.origin);

    if (target.origin !== window.location.origin) {
        return url;
    }

    target.searchParams.set('_g', v1Gate);

    return target.toString();
};

// Every same-origin XHR (axios, jQuery, FilePond) and fetch carries the token; other origins never do.
if (v1Gate) {
    const xhr = window.XMLHttpRequest.prototype;
    const { open, setRequestHeader, send } = xhr;
    const requests = new WeakMap();

    xhr.open = function (method, url) {
        requests.set(this, { sameOrigin: isSameOrigin(url), callerSet: false });

        return open.apply(this, arguments);
    };

    xhr.setRequestHeader = function (name) {
        const request = requests.get(this);

        if (request && String(name).toLowerCase() === 'x-v1-gate') {
            request.callerSet = true;
        }

        return setRequestHeader.apply(this, arguments);
    };

    xhr.send = function () {
        const request = requests.get(this);

        if (request && request.sameOrigin && !request.callerSet) {
            setRequestHeader.call(this, 'X-V1-Gate', v1Gate);
        }

        return send.apply(this, arguments);
    };

    const nativeFetch = window.fetch;

    if (nativeFetch) {
        window.fetch = function (input, init) {
            const isRequest = !!input && typeof input === 'object' && typeof input.url === 'string';

            if (!isSameOrigin(isRequest ? input.url : input)) {
                return nativeFetch.apply(window, arguments);
            }

            // init.headers replaces a Request's own headers, so start from whichever fetch would use.
            const headers = new Headers((init && init.headers) || (isRequest ? input.headers : undefined));

            if (!headers.has('X-V1-Gate')) {
                headers.set('X-V1-Gate', v1Gate);
            }

            return nativeFetch.call(window, input, Object.assign({}, init, { headers }));
        };
    }
}

window.withV1Gate = withV1Gate;
